<div class="page-header">
  <!-- Breadcrumbs -->
  <p-breadcrumb
    *ngIf="breadcrumbs && breadcrumbs.length > 0"
    [model]="breadcrumbs"
    class="page-header__breadcrumbs">
  </p-breadcrumb>

  <!-- Main Content -->
  <div class="page-header__main">
    <!-- Left Section -->
    <div class="page-header__left">
      <!-- Back Button -->
      <button
        *ngIf="showBackButton"
        pButton
        icon="pi pi-arrow-left"
        class="p-button-text p-button-secondary page-header__back"
        (click)="onBack()">
      </button>

      <!-- Icon -->
      <div *ngIf="icon" class="page-header__icon">
        <i [class]="icon"></i>
      </div>

      <!-- Title & Subtitle -->
      <div class="page-header__content">
        <h1 class="page-header__title">{{ title }}</h1>
        <p *ngIf="subtitle" class="page-header__subtitle">{{ subtitle }}</p>
      </div>
    </div>

    <!-- Right Section - Actions -->
    <div class="page-header__actions">
      <button
        *ngIf="secondaryActionLabel"
        pButton
        [label]="secondaryActionLabel"
        [icon]="secondaryActionIcon || ''"
        class="p-button-outlined p-button-secondary"
        (click)="onSecondaryAction()">
      </button>

      <button
        *ngIf="actionLabel"
        pButton
        [label]="actionLabel"
        [icon]="actionIcon || ''"
        class="p-button-primary"
        (click)="onAction()">
      </button>
    </div>
  </div>
</div>
